export const GALLERY_SECTION_TYPES = Object.freeze({
  HERO: 'gallery-hero',
  COLLECTIONS: 'gallery-collections',
  FEATURED: 'gallery-featured-works',
  STORY: 'gallery-statement',
});

export const GALLERY_SECTION_META = Object.freeze([
  { type: GALLERY_SECTION_TYPES.HERO, name: 'Gallery introduction', icon: 'layout', description: 'An editorial, image-led welcome' },
  { type: GALLERY_SECTION_TYPES.COLLECTIONS, name: 'Collection wall', icon: 'grid', description: 'A visual route into your categories' },
  { type: GALLERY_SECTION_TYPES.FEATURED, name: 'Featured works', icon: 'grid', description: 'A curated selection from your catalogue' },
  { type: GALLERY_SECTION_TYPES.STORY, name: 'Gallery statement', icon: 'quote', description: 'A quiet closing brand statement' },
]);

export function createGallerySections() {
  return [
    { id: 'gallery-hero-1', type: GALLERY_SECTION_TYPES.HERO, content: { eyebrow: 'The collection', title: '', body: '', buttonText: 'View the collection', buttonLink: '/shop', image: '', mobileImage: '' }, settings: { minHeight: '760px', contentPosition: 'left', imagePosition: 'center' } },
    { id: 'gallery-collections-1', type: GALLERY_SECTION_TYPES.COLLECTIONS, content: { eyebrow: 'Browse the archive', title: 'Made to be looked at.' }, settings: { maxCategories: 3 } },
    { id: 'gallery-featured-1', type: GALLERY_SECTION_TYPES.FEATURED, content: { eyebrow: 'Selected works', title: 'In focus.', linkText: 'View all', link: '/shop' }, settings: { count: 6 } },
    { id: 'gallery-statement-1', type: GALLERY_SECTION_TYPES.STORY, content: { eyebrow: 'The gallery', title: 'Objects with a point of view.', body: 'Explore a collection shaped by detail, curiosity and a lasting sense of place.', linkText: 'About the store', link: '/about', image: '' }, settings: {} },
  ];
}

export function isGallerySection(section) {
  return GALLERY_SECTION_META.some((item) => item.type === section?.type);
}
